import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Heading, Paragraph } from '@digdir/designsystemet-react';
import classes from './SignUp.module.css';

const PERKS = ['free', 'modules', 'nothingSent', 'stops'] as const;

/** «Dette får du»: the terms of the trial, next to the steps of «Prøv gratis» */
export const Perks = (): ReactElement => {
  const { t } = useTranslation();
  return (
    <section className={classes.perks} aria-labelledby="signup-perks">
      <Heading level={2} data-size="2xs" id="signup-perks">
        {t('auth.signUp.perks.title')}
      </Heading>
      <ul>
        {PERKS.map((perk) => (
          <li key={perk}>
            <span aria-hidden="true" className={classes.check} />
            <Paragraph data-size="sm">{t(`auth.signUp.perks.${perk}`)}</Paragraph>
          </li>
        ))}
      </ul>
    </section>
  );
};
